
import { Logger } from "@ciaopeople/cp-shatsu/Logging/Logger";
import { isArray } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { NotificationDeviceType } from "../../../api/types/SubscriptionTypes.js";
import { ClientSdkPublicInterface } from "../../../sdk/ClientSdkPublicInterface.js";
import { EvaluatedActionType, ProposeAppDownload, ProposeOpenInApp, ProposeOpenInAppWithScheme } from "../../EvaluatedAction.js";

export function executeAppDownload(nt: NotificationDeviceType, sdk: ClientSdkPublicInterface): Promise<void> {
    const cfg = sdk.getConfig();
    if(nt == NotificationDeviceType.ANDROID && cfg.nativeApp.android_alternative_url) {
        document.location.href = cfg.nativeApp.android_alternative_url;
    }
    else if(nt == NotificationDeviceType.IOS && cfg.nativeApp.ios_alternative_url) {
        //questo non si verificherà mai, perchè siamo coperti da smart-app-banners
        document.location.href = cfg.nativeApp.ios_alternative_url;
    }
    return Promise.resolve();
}


export function executeInAppOpen(nt: NotificationDeviceType, sdk: ClientSdkPublicInterface): Promise<void> {
    return executeInAppOpenWithScheme(nt, sdk);
}


export function executeInAppOpenWithScheme(nt: NotificationDeviceType, sdk: ClientSdkPublicInterface): Promise<void> {
    
    sdk.openUrl(
        sdk.toDynamicLink(document.location.href)
    );
    return Promise.resolve();
        
}

export function inAppActionEvaluation(sdk: ClientSdkPublicInterface, logger: Logger): Promise<ProposeOpenInApp|ProposeOpenInAppWithScheme|ProposeAppDownload> {
    
    
    const detected = sdk.webviewDetect();
    if(!detected.native_app) {
        // @task #11419
        if (sdk.getConfig().nativeApp.disabled) {
            logger.debug("Evaluation skipped, property has no app configured");
            return Promise.resolve(null);
        }
        else {
            if(detected.platform.ios) {
                if(detected.browser.webview) {
                    logger.debug("Ios Webview - proposing with scheme");
                    return Promise.resolve({
                        type: EvaluatedActionType.PROPOSE_APP_WITH_SCHEME,
                        data: NotificationDeviceType.IOS
                    });
                }
                else {
                    logger.debug("Ios non Webview - nothing to do ... should be done by smart-app-banners");
                    //qui fa tutto smart-app-banners
                    return Promise.resolve({
                        type: EvaluatedActionType.PROPOSE_APP_WITH_SCHEME,
                        data: NotificationDeviceType.IOS
                    });
                }
            }
            else if(detected.platform.android) {
                if(hasOwnProperty(navigator, "getInstalledRelatedApps")) {
                    logger.debug("Andorid proceeding with getInstalledRelatedApps");
                    return navigator["getInstalledRelatedApps"]().then(resp => {
                        const useType = isArray(resp) && resp.length > 0?EvaluatedActionType.PROPOSE_IN_APP_OPEN:EvaluatedActionType.PROPOSE_APP_DOWNLOAD;
                        return {
                            type: useType,
                            data: NotificationDeviceType.ANDROID
                        };
                    });
                }
                else {
                    logger.debug("Andorid proceeding with scheme");
                    return Promise.resolve({
                        type: EvaluatedActionType.PROPOSE_APP_WITH_SCHEME,
                        data: NotificationDeviceType.ANDROID
                    });
                }
            }

        }
    }
    else {
        logger.debug("Is already native app ... nothing to propose in terms di app refer");
    }
    return Promise.resolve(null);
}